import { api } from "@/features/utils/fetch-server";
import type { Agent } from "../types";

export class AgentsAPI {
  static async list(clientId: string): Promise<{ agents: Agent[] }> {
    return api.get(`/api/configuration/v1/${clientId}/agents`);
  }

  /**
   * A client's agents as platform staff see them on the client's file: names
   * only — the configuration is not what that page is for (read-only staff
   * mount).
   */
  static async listNames(
    clientId: string,
  ): Promise<{ agents: Pick<Agent, "id" | "name">[] }> {
    return api.get(`/api/configuration/v1/staff/${clientId}/agents`);
  }

  static async create(
    clientId: string,
    agent: Partial<Agent>,
  ): Promise<{ agent: Agent }> {
    return api.post(`/api/configuration/v1/${clientId}/agents`, agent);
  }

  static async update(
    clientId: string,
    id: string,
    agent: Partial<Agent>,
  ): Promise<{ agent: Agent }> {
    return api.put(`/api/configuration/v1/${clientId}/agents/${id}`, agent);
  }

  static async delete(clientId: string, id: string): Promise<void> {
    await api.delete(`/api/configuration/v1/${clientId}/agents/${id}`);
  }
}
